import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';
import gsap from 'gsap';
import { useEffect, useRef } from 'react';

import devaWalletLogo from '../../../public/svg/logos/devaWalletLogo.svg';
import evmDebuggerLogo from '../../../public/svg/logos/EVMDebuggerLogo.svg';
import hadoukenLogo from '../../../public/svg/logos/hadoukenLogo.svg';
import makerDaoLogo from '../../../public/svg/logos/makerDaoLogo.svg';
import revelatorLogo from '../../../public/svg/logos/revelatorLogo.svg';
import {
  CompaniesStyledStack,
  StyledCompaniesHeader,
  StyledHeroHeading,
} from './styles';

export const Hero = () => {
  const olRef = useRef<HTMLOListElement>(null);

  const companiesData = [
    makerDaoLogo,
    hadoukenLogo,
    revelatorLogo,
    devaWalletLogo,
    evmDebuggerLogo,
  ];

  const services = [
    'a DEX platform',
    'an NFT marketplace',
    'a lending protocol',
    'a Web3 product',
    'a crypto wallet',
    'a ZK rollup',
    'a dApp',
    'a DeFi product',
    'a blockchain-based MVP',
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (olRef !== null && olRef.current !== null) {
        const spanTimeline = gsap.timeline({
          repeat: -1,
          repeatDelay: 1,
        });

        const serviceItems = olRef.current.childNodes;
        serviceItems.forEach((word, index) => {
          spanTimeline.fromTo(
            'ol',
            {
              '--word-counter': index - 1,
            },
            {
              '--word-counter': index,
              duration: 0.8,
              ease: 'elastic.out(0.4, 3)',
              delay: index === 0 ? 0 : 0.8,
            }
          );
        });
      }
    });
    return () => ctx.revert();
  }, [olRef]);

  return (
    <>
      <MacBookWindow
        title={
          <>
            Let's build <br />
            <ol ref={olRef}>
              {services.map((service, index) => {
                return (
                  <li key={index} className="service-item">
                    <StyledHeroHeading variant="display_sm">
                      {service}
                    </StyledHeroHeading>
                  </li>
                );
              })}
            </ol>
          </>
        }
        description={
          <>
            We build <b>DeFi</b> protocols, DEX platforms, and Web3 products
            that work.
          </>
        }
        buttonText="Book a free consultation"
        buttonLink="/contact"
        gradient="lightBlue"
      />

      <Section width="normal">
        <CompaniesStyledStack>
          <StyledCompaniesHeader variant="strong_400">
            Rumble Fish has built for some of the most demanding products in
            crypto - from leading DeFi protocols to new chains looking to
            integrate with existing liquidity.
            <br />
            Here's a few of them.
          </StyledCompaniesHeader>
          <CompaniesCarousel
            companiesLogos={companiesData}
            shouldInvert={false}
          />
        </CompaniesStyledStack>
      </Section>
    </>
  );
};
